























import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';
import baseSpinner from '@/components/Spinner';
import UgcNewStepsView from "@/components/UGC/UGCMainComponents/NewTopBar/NewStepsView";
import ugc from '@/mixins/UGC';

@Component({
  components: {
    CustomContainer,
    CustomImage,
    baseSpinner,
    UgcNewStepsView
  },
  mixins: [ugc]
})

export default class UgcConfirmDesignStep extends Vue {

  @Prop({default: false})
  showStepsView!: Boolean;

  @Watch('showSpinner')
  public watchShowSpinner (show: boolean){
    (this.$refs.spinner as any).hideSpinner(!show);
  }

  created() {
    this.$eventBus.$on("show-spinner-finish", (this as any).setIsApplyingUGC);
    this.$eventBus.$emit("show-finish-button", true);

    this.$emit('showCtaButton', true);
    this.$emit('showIconButton', false);
    this.$emit('showBackButton', true);

    (this as any).getUgcConfirmDesignImages();
  }

  mounted() {
    let action = (this as any).checkerboarderActive ? 'checkerboarder' : 'ugc';
    if (this.$store.state.transferDesign.isCustomizerTransferredModel) {
      action = 'transferDesign';
    } else if (this.$store.state.ugc?.tempData?.activeUGCIndex === 1) {
      action = 'imageLibrary';
    }
    (this as any).$ugcDataLayer.logAnalyticsEvent({
      action,
      type: (this as any).$ugcDataLayer.types.designLoaded
    });
    (this.$refs.spinner as any).hideSpinner(false);
    this.$store.commit("ugc/stateManager/SET_LOADING", true);
  }

  beforeDestroy() {
    this.$eventBus.$emit("show-finish-button", false);
    this.$eventBus.$off("show-spinner-finish", (this as any).setIsApplyingUGC);
  }
}
